// Slim roster records already contain resolved names, but older consumers also
// use fullName and uppercase sort keys. Fill missing fields without media reads
// or the full-profile mapper, which requires a type that summaries may omit.
function prepareNames(profile, displayName) {
    if (!profile) return;

    if (!profile.actNameString && profile.actName) {
        profile.actNameString = profile.actName.toUpperCase();
    }
    if (!profile.profileNameString && profile.profileName) {
        profile.profileNameString = profile.profileName.toUpperCase();
    }
    if (!profile.fullName && displayName) {
        profile.fullName = displayName;
    }
}

function prepareSummaryNames(profile) {
    if (!profile) return;
    prepareNames(profile, profile.profileName ||
        [profile.firstName, profile.lastName].filter(Boolean).join(" "));
}

export default function prepareAgentActRosterNames(rows) {
    for (const row of rows) {
        prepareNames(row.act, row.act && row.act.actName);
        prepareSummaryNames(row.agent);
        // myMusician is a resolved owner alias, not necessarily a Musician.
        // Preserve each summary independently; either can legitimately be null.
        if (row.act) {
            prepareSummaryNames(row.act.actAdmin);
            prepareSummaryNames(row.act.myMusician);
        }
    }
    return rows;
}
